<template>
  <div :class="$style.container" class="j_main" :style="containerStyles">
    <client-only>
      <CruiseMapContentNew :cruiseId="cruiseId" :searchData="searchParams" :isDefaultState="isDefaultState" />
    </client-only>
    <div :class="$style.aside">
      <index-search @update:search-data="onConfirm" />
      <client-only v-if="hasSearch">
        <index-cruise-list class="mt-2.5" :searchData="searchParams" @load-next="onLoadCruiseList" @reset="onResetFilter" />
      </client-only>
    </div>
    <index-filter :search-data.sync="searchData" @confirm="onConfirm" @reset="onResetFilter" />

    <div :class="$style.right">
      <div :class="$style.btns">
        <dl ref="collectionWrapRef">
          <dt :class="$style.btn" @click="onShowCollection" role="button">
            <i :class="$style.btnIcon" class="ficon ficon-Union" />
            <span class="ml-1">我的收藏</span>
          </dt>
          <dd v-if="isLodedCollection" :class="$style.collectionCard">
            <!-- 延迟加载 index-collection-list 以使得 InfiniteLoading 在展示时触发 load-->
            <index-collection-list @close="isLodedCollection = false" />
          </dd>
        </dl>
        <nuxt-link class="ml-2" :class="$style.btn" to="/" role="button">
          <i :class="$style.btnIcon" class="ficon ficon-shouye" />
          <span class="ml-1">返回首页</span>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script>
// import CruiseMapContentNew from "";
import IndexSearch from "~/components/cruise-map/index-search.vue";
import IndexAside from "~/components/cruise-map/index-aside.vue";
import IndexFilter from "~/components/cruise-map/index-filter.vue";
import IndexCruiseList from "~/components/cruise-map/index-cruise-list.vue";
import IndexCollectionList from "~/components/cruise-map/index-collection-list.vue";
import defineAsyncComponent from "~/utils/defineAsyncComponent";

import {
	useFetch,
	ref,
	// onMounted,
	useRoute,
	// nextTick,
	defineComponent,
	// reactive,
	useStore,
	computed,
	onBeforeMount,
	onUnmounted,
  useMeta
} from "@nuxtjs/composition-api";

// import { toNumber } from "lodash";
// import { getAisCruiseList } from "~/services/company";
// import { REQUEST_CODES } from "~/constants/const-http";

import useCruiseList from "~/composables/cruise-map/useCruiseList";
import { onClickOutside, useWindowSize } from "@vueuse/core";

// 经度-28.516758
// 纬度35.496096

import useLoginDialog from '~/composables/useLoginDialog';
import useLayout from "~/composables/useLayout";

export default defineComponent({
	name: "CruiseMap",
	auth: false,
	layout: "Fill",
	components: {
		// CruiseDetail,
		// CruiseCatalog,
		// CruiseSearch,

		IndexSearch,
		IndexAside,
		IndexFilter,
		IndexCruiseList,
		IndexCollectionList,
		// CruiseMapContent,
		CruiseMapContentNew: defineAsyncComponent(() => import('@/views/cruise-map/cruise-map-content-new.vue'))
	},
	head: {},
	setup() {
		// ======================= Layout =======================
		const {height} = useWindowSize();
		const {headerSize, showAppFooter} = useLayout();
		const containerStyles = computed(() => ({
			height: `${ height.value - headerSize.height }px`
		}))
		showAppFooter.value = false;
		// onBeforeMount(() => {
		// 	showAppFooter.value = false;
		// })
		onUnmounted(() => {
			showAppFooter.value = true;
		})


		const {showLogin} = useLoginDialog();
		const store = useStore();
		const route = useRoute();

		const loading = ref(true);

		// 加载邮轮列表
		useFetch(async () => {
			loading.value = true;
			await store.dispatch("cruiseMap/fetchFilterData");

			loading.value = false;
		});

		const collectionWrapRef = ref();
		const isLodedCollection = ref(false);

		onClickOutside(collectionWrapRef, () => (isLodedCollection.value = false));



		// const dialog = this.$createLoginDialog({
		// 			onSuccess: () => {
		// 				this.isLodedCollection = true;
		// 				dialog.hide();
		// 			},
		// 			onClosed() {
		// 				dialog.remove();
		// 			}
		// 		});
		const onShowCollection = () => {
			if(!store.getters.loggedIn){
				showLogin();
			}else {
				isLodedCollection.value = true;
			}
		}

    useMeta(() => ({
      title:'全球邮轮定位信息查询系统_定位轨迹_船舶公司_船舶类型_航行状态【上船吧邮轮平台】',
      meta: [
        {
          name:'description',
          hid: 'description',
          content:'【上船吧邮轮平台】为您提供全球邮轮定位信息查询,包括搜索查询,定位轨迹,船舶公司,船舶类型,航行状态,吨位,翻新时间,首航时间,热门邮轮公司邮轮定位查询,包括世纪游轮,皇家加勒比邮轮,招商维京游轮,诺唯真邮轮,公主邮轮,庞洛邮轮,地中海邮轮,东方皇家旅游船公司,迪士尼邮轮,歌诗达邮轮,嘉年华邮轮,南极21世纪探险,南海邮轮,长江黄金系列游轮,长江海外游轮,重庆大美游轮,中船嘉年华邮轮,银海邮轮,维多利亚游轮,上海蓝梦国际,名人邮轮,丽思卡尔顿游艇等,邮轮类型包括长江河轮,境外河轮,海洋邮轮,极地邮轮,海洋帆船,渡轮,游艇等'
        },
        {
          name:'keywords',
          hid: 'keywords',
          content:'全球邮轮定位信息查询系统,定位轨迹,船舶公司,船舶类型,航行状态【上船吧邮轮平台】'
        },
      ]
    }))
		// 搜索
		// const hasSearch = computed(() => {
		// 	return
		// })

		return {
			containerStyles,

			showLogin,

			loading,
			// 当前 选中 邮轮id
			cruiseId: computed(() => route.value.query.cruiseId),

			// 是否加载收藏
			isLodedCollection,

			collectionWrapRef,

			onShowCollection,
			...useCruiseList()
		};
	},
	data() {
		return {
			defaultProps: {
				children: "cruise",
				label: "name"
			}
		};
	},
	methods: {
		// onShowCollection() {
		// 	if (this.$store.getters.loggedIn) {
		// 		this.isLodedCollection = true;
		// 	} else {
		// 		const dialog = this.$createLoginDialog({
		// 			onSuccess: () => {
		// 				this.isLodedCollection = true;
		// 				dialog.hide();
		// 			},
		// 			onClosed() {
		// 				dialog.remove();
		// 			}
		// 		});
		// 		dialog.show();
		// 	}
		// }
	}
});
</script>
<style lang="scss" module>
.container {
  min-width: 1366px;
  position: relative;
  width: 100%;
}
.aside {
  position: absolute;
  left: 3rem;
  top: 3rem;
  width: 22.5rem;
}
.main {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  height: 100%;
  position: relative;
  width: 100%;
}
.cruiseDrawer {
  position: absolute;
}
.search {
  position: absolute;
  left: 3rem;
  top: 3rem;
  width: 26.25rem;
  z-index: 10;
}
.right {
  position: absolute;
  right: 3rem;
  top: 3rem;
}
.btns {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.btn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 3rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
.btn:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.btnIcon {
  font-size: 1rem;
  line-height: 1.5rem;
}
.collectionCard {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  margin-top: 0.625rem;
  overflow: hidden;
  position: absolute;
  top: 100%;
  right: 0px;
  width: 22.5rem;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
</style>
